import React, { useEffect, useContext, useState, useRef, RefObject } from 'react';
import { Modal, Form, Button, Dimmer, Loader, Dropdown, Icon, Image as ImageComp } from 'semantic-ui-react';
import UserContext from '../../../contexts/UserContext';
import './style.less';
import { toast } from 'react-toastify';
import { getAllStoriesForResident, markAsRead } from '../../../services/storyResponses';
import AudioRecorder from '../news/services/audioRecorder';
import {
    sendTextMessage,
    getUploadUrl,
    uploadToSignedUrl,
    sendAudioMessage,
    sendImageMessage,
    sendVideoMessage,
} from '../../../services/Messages';
import ModalComponent from '../../components/modalComponent';
import { getMessages, deleteMessage } from '../../../services/Messages';

let recorder;

const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    });
};

const useCheckMobileScreen = () => {
    const [width, setWidth] = useState(window.innerWidth);
    const handleWindowSizeChange = () => {
        setWidth(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);

    return width <= 768;
};

const ResponseComponent = ({
    Image,
    ResidentName,
    response,
    storyType,
    storyText,
    playableUrl,
    imageUrl,
    videoThumbnail,
    videoUrl,
    sentAt,
}) => {
    const nameArray = ResidentName.split(' ');
    const imagePlaceHolderText = `${!!nameArray[0] && nameArray[0].charAt(0).toUpperCase()} ${
        !!nameArray[1] && nameArray[1].charAt(0).toUpperCase()
    }`;
    return (
        <div className="message-reply resident">
            <div className="relative-image-container">
                {Image ? (
                    <div className="relative-image" style={{ background: `url(${Image}) no-repeat` }}></div>
                ) : (
                    <div className="relative-avatar">{imagePlaceHolderText}</div>
                )}
            </div>
            <div className="name-container">
                <p className="name">{ResidentName}</p>
                <div className="resident-reply">
                    {response}
                    {(storyText || playableUrl || imageUrl || videoUrl) ? <p className="replied-to">
                        {imageUrl ? (
                            <>
                                <ImageComp size="medium" src={imageUrl}></ImageComp>
                            </>
                        ) : videoUrl ? (
                            <video controls src={videoUrl} muted={false}>
                                Your browser doesn't support HTML5 video tag.
                            </video>
                        ) : (
                            ''
                        )}
                        {storyType === 'audio' ? (
                            <audio controls src={playableUrl}>
                                Your browser does not support the
                                <code>audio</code> element.
                            </audio>
                        ) : (
                            storyText
                        )}
                    </p> : <></> }
                </div>
                <p className="timestamp">{formatTime(sentAt)}</p>
            </div>
        </div>
    );
};

const MessageComponent = ({
    messageIndex,
    Image,
    RelativeName,
    storyType,
    storyText,
    playableUrl,
    sentAt,
    deleteMessage,
    editMessage,
    videoUrl,
    imageUrl,
    videoThumbnail,
}) => {
    const nameArray = RelativeName.split(' ');
    const imagePlaceHolderText = `${!!nameArray[0] && nameArray[0].charAt(0).toUpperCase()} ${
        !!nameArray[1] && nameArray[1].charAt(0).toUpperCase()
    }`;
    return (
        <div className="message-reply relative">
            <div className="name-container">
                <div className="name">
                    {RelativeName}
                    <span className="options-dropdown">
                        <Dropdown>
                            <Dropdown.Menu className="left">
                                {storyType === 'text' && (
                                    <Dropdown.Item
                                        onClick={() => {
                                            editMessage(messageIndex);
                                        }}
                                    >
                                        <Icon name="edit" className="edit-message" />
                                        Edit
                                    </Dropdown.Item>
                                )}
                                <Dropdown.Item
                                    onClick={() => {
                                        deleteMessage(messageIndex);
                                    }}
                                >
                                    <Icon name="delete" className="delete-message" />
                                    Delete{' '}
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </span>
                </div>
                <div className="relative-message">
                    {imageUrl ? (
                        <ImageComp size="medium" src={imageUrl}></ImageComp>
                    ) : videoUrl ? (
                        <video controls src={videoUrl} muted={false}>
                            Your browser doesn't support HTML5 video tag.
                        </video>
                    ) : (
                        ''
                    )}
                    {storyType === 'audio' ? (
                        <audio controls src={playableUrl}>
                            Your browser does not support the
                            <code>audio</code> element.
                        </audio>
                    ) : (
                        storyText
                    )}
                </div>
                <p className="timestamp">{formatTime(sentAt)}</p>
            </div>
            <div className="relative-image-container">
                {Image ? (
                    <div className="relative-image" style={{ background: `url(${Image}) no-repeat` }}></div>
                ) : (
                    <div className="relative-avatar">{imagePlaceHolderText}</div>
                )}
            </div>
        </div>
    );
};

const Messages = (props) => {
    const residentIdFromProps = props.residentId;
    const [loading, setLoading] = useState(true);
    const [responses, setResponses] = useState<any>([]);

    const { userObject, setUser } = useContext(UserContext);
    const [residentId, setResidentId] = useState();

    const defaultInputMessage =
        'Type your message (it will be read using Alexa’s voice) or use one of the buttons to send using audio, video or photo';

    const [inputMessage, setInputMessage] = useState<string>('');
    const [recording, setRecordingIcon] = useState<boolean>(false);
    const [textAreaValue, setTextAreaValue] = useState<string>('');
    const [textAreaActive, setTextAreaActive] = useState<boolean>(false);
    const [audioExists, setAudioExists] = useState<boolean>(false);
    const [sendingMessage, setSendingMessage] = useState<boolean>(false);

    const [selectedMessageIndex, setSelectedMessageIndex] = useState<number>(0);
    const [openModal, setOpenModal] = useState<boolean>(false);
    const textArea: RefObject<HTMLTextAreaElement> = useRef(null);
    const audioPlayer: RefObject<HTMLAudioElement> = useRef(null);
    const [audioBlob, setAudioBlob] = useState();
    const listRef = useRef(null);
    const listContainerRef = useRef(null);
    const bottomRef = useRef(null);
    const [imageFile, setMessageImage] = useState();
    const [videoFile, setMessageVideo] = useState();
    const isMobile = useCheckMobileScreen();


    const checkVideoResolution = (file: File): Promise<{ width: number, height: number }> => {
        return new Promise((resolve, reject) => {
          const videoElement = document.createElement('video');
      
          videoElement.onloadedmetadata = () => {
            const { videoWidth, videoHeight } = videoElement;
            resolve({ width: videoWidth, height: videoHeight });
          };
      
          videoElement.onerror = () => {
            reject(new Error('Failed to load the video.'));
          };
      
          videoElement.src = URL.createObjectURL(file);
        });
      };

    const fileChange = async (event) => {
        const file = event.target.files[0];
        const fileType = file.type.split('/')[0];
        if (fileType === 'video') {
            const { width, height } = await checkVideoResolution(file);
            if (height < 1080 || width < 1920) 
                setMessageVideo(file);
            else
                toast.error('The video you provided is of a higher resolution, only videos upto 720p can be played on Alexa devices.', {
                    position: 'bottom-center',
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                });
        } else {
            setMessageImage(file);
            scrollToBottom(bottomRef);
        }
    };

    const beginRecording = async () => {
        try {
            recorder = await AudioRecorder();
            recorder.record();

            setInputMessage('Recording...');
            setRecordingIcon(true);
        } catch (e) {
            alert('Could not record audio. Please make sure you have allowed your browser to record audio');
        }
    };

    const stopRecording = async () => {
        if (recorder) {
            const blob = await recorder.stop();

            setAudioBlob(blob);

            setAudioExists(true);

            setInputMessage(defaultInputMessage);
            setRecordingIcon(false);
        }
    };

    const activateTextarea = () => {
        setTextAreaActive(true);
        if (textArea.current) {
            textArea.current.focus();
        }
    };

    const deactivateTextarea = () => {
        setTextAreaActive(false);
    };

    const clearMessageInput = (message) => {
        setInputMessage(message);
        setMessageImage(undefined);
        setMessageVideo(undefined);
        setAudioBlob(undefined);
        setAudioExists(false);
        setTextAreaValue('');
        deactivateTextarea();
        setSendingMessage(false);
    };

    const submitMessage = async () => {
        setLoading(true);
        const residentId = userObject.registrants.list[userObject.registrants.activeRegistrantsIndexes]._id;
        if (audioBlob && !imageFile) {
            setSendingMessage(true);
            const { audioId, signedUrl } = await getUploadUrl();
            const file = new File([audioBlob], audioId, {
                type: 'audio/wav',
            });
            const result = await uploadToSignedUrl(file, signedUrl);
            const messageSent = await sendAudioMessage(audioId.replace(/\.wav$/, '.mp3'), residentId);
            if (messageSent) {
                clearMessageInput('Your message has been sent successfully.');
                getAllStoriesForResident(residentId).then((e) => {
                    setLoading(false);
                    setResponses(e);
                    markAsRead(residentId);
                });
                setLoading(false);
                scrollToBottom(bottomRef);
                return;
            }
            clearMessageInput('There was a problem sending your message.');
        } else if (imageFile) {
            setSendingMessage(true);
            const type = imageFile && imageFile.type.split('/')[1];
            console.log(type);

            const { audioId: imageId, signedUrl } = await getUploadUrl(type);
            console.log(imageId);
            const result = await uploadToSignedUrl(imageFile, signedUrl);

            let audioFileId = undefined;
            if (audioBlob) {
                const { audioId, signedUrl } = await getUploadUrl();
                const file = new File([audioBlob], audioId, {
                    type: 'audio/wav',
                });
                const result = await uploadToSignedUrl(file, signedUrl);
                audioFileId = audioId;
            }

            const messageSent = await sendImageMessage(imageId, textAreaValue, audioFileId, residentId);
            if (messageSent) {
                clearMessageInput('Your message has been sent successfully.');
                getAllStoriesForResident(residentId).then((e) => {
                    setLoading(false);
                    setResponses(e);
                    markAsRead(residentId);
                });
                setLoading(false);
                scrollToBottom(bottomRef);
                setMessageImage('');
                return;
            }

            clearMessageInput('There was a problem sending your message.');
        } else if (videoFile) {
            setSendingMessage(true);
            const type = videoFile && videoFile.type.split('/')[1];
            const { audioId, signedUrl } = await getUploadUrl(type);

            const result = await uploadToSignedUrl(videoFile, signedUrl);
            const messageSent = await sendVideoMessage(audioId, residentId);
            if (messageSent) {
                clearMessageInput('Your message has been sent successfully.');
                getAllStoriesForResident(residentId).then((e) => {
                    setLoading(false);
                    setResponses(e);
                    markAsRead(residentId);
                });
                setLoading(false);
                scrollToBottom(bottomRef);
                setMessageImage('');
                return;
            }

            clearMessageInput('There was a problem sending your message.');
        } else if (textAreaValue) {
            setSendingMessage(true);
            const messageSent = await sendTextMessage(textAreaValue, residentId);
            if (messageSent) {
                clearMessageInput('Your message has been sent successfully.');
                getAllStoriesForResident(residentId).then((e) => {
                    setLoading(false);
                    setResponses(e);
                    markAsRead(residentId);
                });
                setLoading(false);
                scrollToBottom(bottomRef);
                return;
            }
            clearMessageInput('There was a problem sending your message.');
        }
    };

    useEffect(() => {
        if (residentIdFromProps) {
            setResidentId(residentIdFromProps);
        } else {
            const residentIdFromPath = props.match && props.match.params.messageRecipientId;
            const indexOfResidentFromPath = userObject.registrants.list
                .map((registrant) => registrant._id)
                .indexOf(residentIdFromPath);

            if (indexOfResidentFromPath === -1) {
                props.history && props.history.push('/messages');
                return;
            } else if (indexOfResidentFromPath !== userObject.registrants.activeRegistrantsIndexes[0]) {
                setUser({
                    ...userObject,
                    registrants: { ...userObject.registrants, activeRegistrantsIndexes: [indexOfResidentFromPath] },
                });
                setResidentId(residentIdFromPath);
            } else if (indexOfResidentFromPath === userObject.registrants.activeRegistrantsIndexes[0]) {
                setResidentId(residentIdFromPath);
            }
        }
    }, []);

    useEffect(() => {
        if (!residentId) {
            return;
        }
        setLoading(true);
        !residentIdFromProps && props.history.push(`/messages/${residentId}`);
        getAllStoriesForResident(residentId).then((e) => {
            setLoading(false);
            setResponses(e);
            scrollToBottom(bottomRef);
            markAsRead(residentId);
        });
    }, [residentId]);

    useEffect(() => {
        if (residentId) {
            setResidentId(userObject.registrants.list[userObject.registrants.activeRegistrantsIndexes[0]]._id);
        }
    }, [userObject.registrants.activeRegistrantsIndexes]);

    useEffect(() => {
        videoFile && submitMessage();
    }, [videoFile]);

    const scrollToBottom = (ref) => {
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const deleteSelectedMessage = async (messageIndex) => {
        const { _id } = responses[messageIndex];
        setLoading(true);
        const deleteResponse = await deleteMessage(residentId, _id);
        if (deleteResponse) {
            toast.success('Message successfully deleted', {
                position: 'bottom-center',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
            });
            getAllStoriesForResident(residentId).then((e) => {
                setLoading(false);
                setResponses(e);
                markAsRead(residentId);
            });
            setLoading(false);
            return;
        }
        toast.error('There was a problem deleting the message', {
            position: 'bottom-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
        });
        setLoading(false);
    };

    const editMessage = (index) => {
        setSelectedMessageIndex(index);
        setOpenModal(true);
    };

    const refreshMessageReponses = () => {
        getAllStoriesForResident(residentId).then((e) => {
            setLoading(false);
            setResponses(e);
            markAsRead(residentId);
        });
    };

    const {
        userObject: {
            registrants: { list: listOfResidents, activeRegistrantsIndexes },
        },
    } = useContext(UserContext);


    const isDisabledForPayment = activeRegistrantsIndexes[0] === 'all-users' ? false : !(activeRegistrantsIndexes
    .filter(
        (residentIndex) =>
            !listOfResidents[residentIndex].isDisabledForPayment
    ).length)

    return ( 
        <div>
            { isDisabledForPayment ? (
                <div className="no-invites">
                    This user(s) does not have an active Speak2 Family subscription. Please contact their Admin
                    to update their subscription to use Speak2 Family.
                </div>
            ) : (
                <div className="messages-and-replies-page pb-70">
                    <Dimmer className="mt-80" active={loading} inverted>
                        <Loader active={loading} />
                    </Dimmer>
                    {responses && responses.length ? (
                        <div className="messages-and-replies" ref={listContainerRef}>
                            <div className="relative-list" ref={listRef}>
                                {responses.map((response, index) => {
                                    const { To } = response;
                                    if (To === 'Relative') {
                                        const {
                                            residentName,
                                            story: { type, text, playableUrl, videoUrl, imageUrl, videoThumbnail },
                                            residentImage: image,
                                            responseText,
                                            sentAt,
                                        } = response;
                                        return (
                                            <ResponseComponent
                                                Image={image}
                                                ResidentName={residentName}
                                                response={responseText}
                                                storyType={type}
                                                storyText={text}
                                                playableUrl={playableUrl}
                                                sentAt={sentAt}
                                                videoUrl={videoUrl}
                                                imageUrl={imageUrl}
                                                videoThumbnail={videoThumbnail}
                                            />
                                        );
                                    } else {
                                        const {
                                            relativeName,
                                            relativeImage: image,
                                            type,
                                            playableUrl,
                                            videoUrl,
                                            imageUrl,
                                            videoThumbnail,
                                            text,
                                            sentAt,
                                            _id,
                                        } = response;
                                        return (
                                            <MessageComponent
                                                messageIndex={index}
                                                Image={image}
                                                RelativeName={relativeName}
                                                storyType={type}
                                                storyText={text}
                                                playableUrl={playableUrl}
                                                sentAt={sentAt}
                                                deleteMessage={deleteSelectedMessage}
                                                editMessage={editMessage}
                                                videoUrl={videoUrl}
                                                imageUrl={imageUrl}
                                                videoThumbnail={videoThumbnail}
                                            />
                                        );
                                    }
                                })}
                            </div>
                            <div ref={bottomRef}></div>
                    </div>
                ) : (
                    <div className="no-messages">
                        There are no new messages to display. Click below to send a message and start a conversation.
                    </div>
                )}
                <div className="relative-list message-reply-input">
                    {imageFile && (
                        <div className="">
                            <img className="preview-image" src={URL.createObjectURL(imageFile)}></img>
                        </div>
                    )}
                    <div className="relative-list message-reply-input">
                        {imageFile && (
                            <div className="">
                                <img className="preview-image" src={URL.createObjectURL(imageFile)}></img>
                            </div>
                        )}
                        <div className="input-container">
                            {!recording && !audioExists && (
                                <>
                                    <textarea
                                        ref={textArea}
                                        name=""
                                        id=""
                                        onBlur={deactivateTextarea}
                                        value={textAreaValue}
                                        onChange={(e) => setTextAreaValue(e.target.value)}
                                        onClick={activateTextarea}
                                        className={textAreaValue && 'overflow'}
                                        rows={4}
                                        placeholder={!imageFile ? defaultInputMessage : ''}
                                    />
                                    <div className="recording-state-image">
                                        {textAreaValue || imageFile ? (
                                            <Icon name="send" onClick={submitMessage} />
                                        ) : (
                                            <img src="/microphone.svg" onClick={beginRecording}></img>
                                        )}
                                    </div>
                                    <div className="recording-state-image">
                                        {imageFile ? (
                                            <Icon
                                                name="cancel"
                                                onClick={() => {
                                                    clearMessageInput(defaultInputMessage);
                                                }}
                                            />
                                        ) : (
                                            <label>
                                                {isMobile ? <img src="/camera.svg"></img> : <img src="/gallery.svg"></img>}
                                                <input
                                                    style={{ display: 'none' }}
                                                    type="file"
                                                    accept="image/*,video/*"
                                                    multiple={false}
                                                    onChange={fileChange}
                                                ></input>
                                            </label>
                                        )}
                                    </div>
                                </>
                            )}
                            {recording && (
                                <>
                                    <div className="recording-audio">
                                        <span className="recording-button"></span>
                                        <span>Recording Audio</span>
                                    </div>
                                    <div className="recording-state-image">
                                        <Button className="small stop-button" onClick={stopRecording}>
                                            <Icon name="stop" />
                                        </Button>
                                    </div>
                                </>
                            )}
                            {audioExists && (
                                <>
                                    <div className="audio-exists">
                                        <Button
                                            className="small"
                                            onClick={() => {
                                                if (!audioPlayer || !audioPlayer.current) {
                                                    return;
                                                }
                                                audioPlayer.current.src = recorder.play();
                                                audioPlayer.current.play();
                                            }}
                                        >
                                            <Icon name="play" />
                                            Play
                                        </Button>
                                        <Button className="small" onClick={clearMessageInput}>
                                            Cancel
                                        </Button>
                                    </div>
                                    <div className="recording-state-image">
                                        <Button className="small" onClick={submitMessage}>
                                            Send Audio
                                            <Icon name="send" />
                                        </Button>
                                    </div>
                                </>
                            )}
                            <div style={{ visibility: 'hidden', height: 0 }}>
                                <audio ref={audioPlayer}></audio>
                            </div>
                            {responses && (
                                <ModalComponent
                                    open={openModal}
                                    setOpen={setOpenModal}
                                    message={
                                        responses &&
                                        responses.length &&
                                        responses[selectedMessageIndex] &&
                                        responses[selectedMessageIndex].text
                                    }
                                    residentId={residentId}
                                    messageId={
                                        responses &&
                                        responses.length &&
                                        responses[selectedMessageIndex] &&
                                        responses[selectedMessageIndex]._id
                                    }
                                    getPreviousMessages={refreshMessageReponses}
                                />
                            )}
                        </div>
                    </div>
                </div>
                </div>

            )}
        </div>
    );
};

export default Messages;
